import "./AppDownload.css";
import PdfIcon from "../../Images/pdf.png";
import ZoomPdf from "../../PDFs/UserGuideZoom.pdf";
import ZoomAdminPdf from "../../PDFs/AdminGuideZoom.pdf";
import WebexUserPdf from "../../PDFs/UserGuideWebex.pdf";
import WebexAdminPdf from "../../PDFs/AdminGuideWebex.pdf";
import MicrosoftUserPdf from "../../PDFs/UserGuideMSTeams.pdf";
import MicrosoftAdminPdf from "../../PDFs/AdminGuideMSTeams.pdf";
import PropTypes from 'prop-types';

const AppDownload = ({ image, title, pdfFiles }) => {
  const getPdfUrl = (pdfName) => {
    switch (pdfName) {
      case 'ZoomPdf':
        return ZoomPdf;
      case 'WebexUserPdf':
        return WebexUserPdf;
      case 'WebexAdminPdf':
        return WebexAdminPdf;
      case 'MicrosoftUserPdf':
        return MicrosoftUserPdf;
      case 'MicrosoftAdminPdf':
        return MicrosoftAdminPdf;
      case 'ZoomAdminPdf':
        return ZoomAdminPdf;
      default:
        return '/';
    }
  };

  const onDownloadClick = (pdfName) => {
    const pdfUrl = getPdfUrl(pdfName);
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = pdfName; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="app-container">
      <div className="app-inner">
        <img className="image" src={image} alt={title} />
        <div className="text-contan">
          <p>{title}</p>
          <div className='pdf-container'>
          {pdfFiles.map((file) => (
            <button 
              key={file.pdfName} 
              onClick={() => onDownloadClick(file.pdfName)} 
              style={{ 
                cursor: "pointer", 
                marginRight: "20px", 
                background: "none", 
                border: "none", 
                padding: 0, 
                textDecoration: "underline", 
                display: "inline",
              }}
              aria-label={`Download ${file.displayName}`}
            >
              <img src={PdfIcon} alt="PDF" />
              {file.displayName}
            </button>
          ))}
          </div>
        </div>
      </div>
    </div>
  );
};

AppDownload.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  pdfFiles: PropTypes.arrayOf(
    PropTypes.shape({
      pdfName: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired,
    })
  ).isRequired,
};


export default AppDownload;
